var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11612 1.22719C1.60427 0.704218 2.39573 0.704218 2.88388 1.22719L9.5 8.31518L16.1161 1.22719C16.6043 0.704218 17.3957 0.704218 17.8839 1.22719C18.372 1.75016 18.372 2.59807 17.8839 3.12104L11.2678 10.209L17.8839 17.297C18.372 17.82 18.372 18.6679 17.8839 19.1909C17.3957 19.7138 16.6043 19.7138 16.1161 19.1909L9.5 12.1029L2.88388 19.1909C2.39573 19.7138 1.60427 19.7138 1.11612 19.1909C0.627961 18.6679 0.627961 17.82 1.11612 17.297L7.73223 10.209L1.11612 3.12104C0.627961 2.59807 0.627961 1.75016 1.11612 1.22719Z",
    fill: "var(--black-text)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconMedium);
export default __webpack_public_path__ + "static/media/close-icon-medium.cb914aceb20262c6cba21c5606899625.svg";
export { ForwardRef as ReactComponent };